/**
 * @fileoverview GET handler for the "/generative_ai/agents/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsTags } from "./constants";
import type { GenerativeAiAgentsTagsResult } from "./types";

export const getGenerativeAiAgentsTags = reactQueryFetcherAdapter(
  generativeAiAgentsTags,
  (signal: AbortSignal, appGroupId: string): Promise<GenerativeAiAgentsTagsResult> => {
    return fetch("/generative_ai/agents/tags", "GET", { app_group_id: appGroupId }, { signal });
  }
);
